'use client';

import { faRocket } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const SalonWebsiteBanner = () => {
  const path = usePathname();

  if (path.startsWith('/salon-websites')) {
    return null;
  }

  return (
    <aside className="bg-base-content text-base-100">
      <div className="px-2 pb-3 pt-4 sm:py-2 flex flex-col sm:flex-row mx-auto max-w-lg gap-4">
        <div className="flex gap-3 items-center justify-center">
          <FontAwesomeIcon icon={faRocket} />

          <p className="tracking-wide">
            New Product Launch: <strong>Salon Websites</strong>
          </p>
        </div>

        <Link href="/salon-websites" className="btn btn-xs">
          Find out more
        </Link>
      </div>
    </aside>
  );
};

export default SalonWebsiteBanner;
